import queryFrom, { defaultQuery } from './queryFrom';
defaultQuery.from = queryFrom;
export default defaultQuery;
var queryAll = defaultQuery.all,
    queryAncestor = defaultQuery.ancestor,
    queryEl = defaultQuery.el,
    queryOne = defaultQuery.one;
export { queryAll, queryAncestor, queryEl, queryOne, queryFrom };